$(function()
{
    if (!$('#forms\\/complaint').length)
    {
        return;
    }

    let $body = $('body');
    let languageCode = $('html').attr('lang');
    let productIndex = 1;
    let $form = $('.js-complaint__form');
    let $productContainer = $('.js-complaint__product-form-container');
    let $additionalProductButton = $('.js-complaint__additional-product-form-button');
    let $additionalProductForm = $('.js-complaint__product-form');
    let $hiddenProductForm = $('.js-complaint__hidden-product-form');
    let deleteAdditionalProductButtonText = $('.js-complaint__product-form-container')
        .data('complaint-delete-product-text');
    let $resetButton = $('.js-complaint__reset-button');
    let $checkButton = $('.js-complaint__check-button');
    let $checkButtonText = $('.js-complaint__check-button--text');
    let $submitButton = $('.js-complaint__submit-button');
    let api = orion.api.complaints;
    let $loadingIndicatorForm = $('#new-complaint .loading-indicator');
    let $loadingIndicatorList = $('#complaint-overview .loading-indicator');

    // Feedback texts
    let feedbackFormatValidationText = $('meta[itemprop="feedback-format-validation-text"]').attr('content');
    let feedbackInvalidFileText = $('meta[itemprop="feedback-invalid-file-text"]').attr('content');
    let feedbackProductInvalidText = $('meta[itemprop="feedback-product-invalid-text"]').attr('content');
    let feedbackProductAvailabilityText = $('meta[itemprop="feedback-product-availability-text"]').attr('content');
    let feedbackEmptyListText = $('meta[itemprop="feedback-empty-list-text"]').attr('content');
    let feedbackFailureListText = $('meta[itemprop="feedback-failure-list-text"]').attr('content');

    // Handle click on AddProductButton
    function handleAdditionalProductButtonClick(event)
    {
        event.preventDefault();
        addAdditionalProduct({});
    }

    // Handle click on CheckButton
    function handleCheckButtonClick(event)
    {
        event.preventDefault();
        $checkButton.prop('disabled', true);
        $checkButtonText.addClass('hidden');
        $loadingIndicatorForm.removeClass('loading-indicator--hidden');

        $form.trigger(orion.constants.EventFormValidate);

        let errors = $form.find('div.error');
        let $products = $('.js-complaint__product-form');

        let validArray = [];
        let availableProductsArray = [];
        let notAvailableProductsArray = [];
        let faultyArray = [];

        if (!errors.length)
        {
            $products.each(function(index)
            {
                let productNumber = $(this).find('.productNumber input')
                    .val();
                let quantity = $(this).find('.quantity input')
                    .val();
                let reason = $(this).find('.reason input')
                    .val();

                let productNumberValidation = checkIfProductNumberInvalid(productNumber);
                let quantityValidation = checkIfProductQuantityInvalid(quantity);
                let reasonValidation = checkIfProductReasonInvalid(reason);

                if (productNumberValidation && quantityValidation && reasonValidation)
                {
                    validArray.push({ productNumber, quantity, reason });

                    $.ajax({ url: '/api-product-' + languageCode + '/' + productNumber,
                        success: function()
                        {
                            availableProductsArray.push(productNumber);
                        },
                        error: function()
                        {
                            notAvailableProductsArray.push(productNumber);
                        },
                        complete: function()
                        {
                            if (
                                notAvailableProductsArray.length
                                && availableProductsArray.length + notAvailableProductsArray.length + faultyArray.length
                                == $products.length
                            )
                            {
                                let notAvailableProducts = notAvailableProductsArray.join(', ');

                                $body.append(
                                    '<div class="feedback info js-feedback js-feedback-autohide">'
                                    + '<i class="fa-regular fa-info-circle"></i><p>'
                                    + feedbackProductAvailabilityText
                                    + '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>'
                                );
                                $('.js-complaint-product-not-available').text(notAvailableProducts);
                                $body.trigger('feedback-added');
                            }

                            if (
                                availableProductsArray.length + notAvailableProductsArray.length + faultyArray.length
                                == $products.length
                            )
                            {
                                if (!faultyArray.length)
                                {
                                    unlockFurtherProcessing();
                                }

                                $checkButton.prop('disabled', false);
                                $checkButtonText.removeClass('hidden');
                                $loadingIndicatorForm.addClass('loading-indicator--hidden');
                            }
                        }
                    });
                }
                else
                {
                    faultyArray.push(index + 1);
                }

                if (index == $products.length - 1)
                {
                    let json = JSON.stringify(validArray);

                    $hiddenProductForm.val(json);

                    if (faultyArray.length)
                    {
                        let faultyProducts = faultyArray.join(', ');

                        $body.append('<div class="feedback error js-feedback js-feedback-autohide">'
									+ '<i class="fa-regular fa-exclamation-circle"></i><p>'
									+ feedbackProductInvalidText
									+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
                        $('.js-complaint-product-invalid').text(faultyProducts);
                        $body.trigger('feedback-added');
                    }
                }
            });
        }
        else
        {
            document.querySelector('div.error').scrollIntoView({ behavior: 'smooth', block: 'center' });
            $checkButton.prop('disabled', false);
            $checkButtonText.removeClass('hidden');
            $loadingIndicatorForm.addClass('loading-indicator--hidden');
        }
    }

    // Handle click on ResetButton
    function handleResetButtonClick()
    {
        let $firstProductFormInputs = $('.js-complaint__product-form:first input');
        let $otherProductForms = $('.js-complaint__product-form:not(:first)');

        $firstProductFormInputs.val('');
        $otherProductForms.remove();
    }

    // Handle changes in form
    function handleChangesForm()
    {
        lockFurtherProcessing();
    }

    // Copy additional complaint form and add delete button
    function addAdditionalProduct()
    {
        let $formClone = $additionalProductForm.clone(true);
        let $newForm = prepareProductForm($formClone, true);
        let $removeButton = $('<a>');

        $removeButton.html('<i class="fa-regular fa-circle-xmark"></i> ' + deleteAdditionalProductButtonText);
        $removeButton.addClass('js-complaint__product-form_delete-button complaint-form-link-delete-product');
        $removeButton.on('click', (event) =>
        {
            event.preventDefault();
            $newForm.remove();
            productIndex = 1;
            reindexProductFormsOnDelete();
            lockFurtherProcessing();
        });

        $newForm.append($removeButton);
        $productContainer.append($newForm);

        return $newForm;
    }

    // Reindex product forms on delete
    function reindexProductFormsOnDelete()
    {
        let $productForms = $('.js-complaint__product-form:not(:first)');

        $productForms.each(function()
        {
            let $form = $(this);

            prepareProductForm($form, false);
        });
    }

    // Prepare additional product form
    function prepareProductForm($form, newProductForm)
    {
        let $title = $form.find('h2');
        let text = $title.text().slice(0, -1);
        let $fields = $form.children('div');
        let $inputs = $form.find('input');

        $title.text(text + (productIndex + 1));
        $fields.removeClass('error missing invalid');

        $inputs.each(function()
        {
            let $input = $(this);
            let inputName = $input.attr('name');
            let labelName = $input.attr('name');
            let newName = inputName.replace(new RegExp(/\d+/), productIndex);

            if (newProductForm)
            {
                $input.val('');
            }

            $input.attr('name', newName);
            $input.attr('id', newName);
            $('label[for="' + labelName + '"]', $form).attr('for', newName);
            $input.attr('required', true);
        });

        productIndex++;

        return $form;
    }

    // Show submit button
    function unlockFurtherProcessing()
    {
        $checkButton.addClass('hidden');
        $submitButton.removeClass('hidden');
    }

    // Hide submit button
    function lockFurtherProcessing()
    {
        $checkButton.removeClass('hidden');
        $submitButton.addClass('hidden');
    }

    /**
	 * CSV UPLOAD
	 */
    let $uploadFile = $('#upload-file');
    let $dragAndDropField = $('#drag-and-drop-field');

    // Drag & Drop
    function handleDragOver(event)
    {
        event.stopPropagation();
        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'copy';
    }

    // Upload file
    function handleFileSelect(event)
    {
        event.stopPropagation();
        event.preventDefault();

        let file = '';

        if (event.originalEvent.target.files !== undefined)
        {
            [file] = event.originalEvent.target.files;
            $('#upload-file').val('');
        }
        else
        {
            [file] = event.originalEvent.dataTransfer.files;
        }
        if (file !== undefined && (file.name.endsWith('.csv') || file.name.endsWith('.txt')))
        {
            let $window = $(window);
            let reader = new FileReader();

            reader.readAsText(file);
            reader.onprogress = function()
            {
                $window.on('beforeunload', function()
                {
                    return false;
                });
            };
            reader.onload = function(event)
            {
                let csv = event.target.result;

                processCsvFile(csv);
                $window.off('beforeunload');
            };
        }
        else
        {
            $body.append('<div class="feedback error js-feedback js-feedback-autohide">'
				+ '<i class="fa-regular fa-exclamation-circle"></i><p>'
				+ feedbackInvalidFileText
				+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
            $body.trigger('feedback-added');
        }
    }

    // Process uploaded csv file
    function processCsvFile(csv)
    {
        let rawCsvArray = csv.trim().split('\n');
        let invalidCsvLines = [];

        for (let i = 0; i < rawCsvArray.length; i++)
        {
            let rawCsvLine = rawCsvArray[i];

            if ($.trim(rawCsvLine) !== '')
            {
                let rawCsvLineArray = convertCsvLineToArray(rawCsvLine);
                let csvLineProductnumber = editRawCsvLine(rawCsvLineArray[0]);
                let csvLineQuantity = editRawCsvLine(rawCsvLineArray[1]);
                let [,, csvLineReason] = rawCsvLineArray;
                let csvLine = csvLineProductnumber + ',' + csvLineQuantity + ',' + csvLineReason;

                if (csvLineValidation(csvLine))
                {
                    let csvLineArray = convertCsvLineToArray(csvLine);

                    createProductForms(csvLineArray);
                }
                else
                {
                    invalidCsvLines.push(i + 1);
                }
            }
        }
        if (invalidCsvLines.length)
        {
            let invalidCsvLinesString = invalidCsvLines.join(', ');

            $body.append('<div class="feedback error js-feedback">'
						+ '<i class="fa-regular fa-exclamation-circle"></i><p'
						+ feedbackFormatValidationText
						+ '</p><a href="#" class="close"><i class="fa-regular fa-times"></i></a></div>');
            $('.js-complaint-csv-row-invalid').text(invalidCsvLinesString);
            $body.trigger('feedback-added');
        }
    }

    // Create new product form
    function createProductForms(csvLineArray)
    {
        let [productNumber] = csvLineArray;
        let [, quantity] = csvLineArray;
        let [,, reason] = csvLineArray;
        let $productForm = $additionalProductForm;

        if (
            $productForm.find('.js-complaint-productform-productnumber').val()
            && $productForm.find('.js-complaint-productform-quantity').val()
        )
        {
            $productForm = addAdditionalProduct();
        }
        $productForm.find('.js-complaint-productform-productnumber').val(productNumber);
        $productForm.find('.js-complaint-productform-quantity').val(quantity);
        $productForm.find('.js-complaint-productform-reason').val(reason);
    }

    // Cleanup csv line
    function editRawCsvLine(rawCsvLine)
    {
        let cleanCsvLine = rawCsvLine;

        cleanCsvLine = cleanCsvLine.replace(/ /g, '');
        cleanCsvLine = cleanCsvLine.replace(/-/g, '');
        cleanCsvLine = cleanCsvLine.replace(/\./g, '');

        return cleanCsvLine;
    }

    // Validate entire csv line
    function csvLineValidation(csvLine)
    {
        let pattern = /^(?:\d{6,7}|\d{10,11})([,;\t]{1})([1-9]{1}[0-9]{0,3})([,;\t]{1})(.|\s)*\S(.|\s)*$/;

        return pattern.test(csvLine);
    }

    // Convert csv line to an array
    function convertCsvLineToArray(csvLine)
    {
        let pattern = /[,;\t]/;
        let csvLineArray = csvLine.split(pattern);

        return csvLineArray;
    }

    // Check if productnumber is valid
    function checkIfProductNumberInvalid(productNumber)
    {
        let pattern = /^(?:\d{6,7}|\d{10,11})$/;

        return pattern.test(productNumber);
    }

    // Check if quantity is valid
    function checkIfProductQuantityInvalid(quantity)
    {
        let pattern = /^[1-9]{1}[0-9]{0,3}$/;

        return pattern.test(quantity);
    }

    // Check if reason is valid
    function checkIfProductReasonInvalid(reason)
    {
        let pattern = /(.|\s)*\S(.|\s)*/;

        return pattern.test(reason);
    }

    function fetchComplaints()
    {
        $loadingIndicatorList.removeClass('loading-indicator--hidden');
        api.read()
            .done((data) =>
            {
                $loadingIndicatorList.addClass('loading-indicator--hidden');
                $('.js-complaint__list').append(data);
            })
            .fail((jqXHR) =>
            {
                let statusCode = jqXHR.status,
                    listMessage;

                $loadingIndicatorList.addClass('loading-indicator--hidden');
                if (statusCode == 404)
                {
                    listMessage = feedbackEmptyListText;
                }
                else
                {
                    listMessage = feedbackFailureListText;
                }
                $('.js-complaint__list').append(
                    '<div class="complaint__list--empty">'
				+ listMessage
				+ '</div>'
                );
            });
    }

    fetchComplaints();

    /**
	 * EVENT LISTENERS
	 */
    $form.on('input', handleChangesForm);
    $additionalProductButton.on('click', handleAdditionalProductButtonClick);

    $dragAndDropField.on('dragover', handleDragOver);
    $dragAndDropField.on('drop', handleFileSelect);
    $uploadFile.on('change', handleFileSelect);

    $resetButton.on('click', handleResetButtonClick);
    $checkButton.on('click', handleCheckButtonClick);
});

